import React from "react";
import { MultipleUsersOutlined, StudentOutlined } from "@toddle-edu/ds-icons";

export const TEST_ID_PREFIX = "academic-records-header-right-component";

export const IMPORT_OPTION_KEYS = {
  RATINGS_SINGLE: "ratings_single",
  RATINGS_MULTIPLE: "ratings_multiple",
  BASIC_DETAILS_SINGLE: "basic_details_single",
  BASIC_DETAILS_MULTIPLE: "basic_details_multiple",
};

export const getImportDropdownOptions = t => [
  {
    key: "academic_records",
    label: t("transcript:bulk_import_academic_records"),
    subText: t("transcript:bulk_import_academic_records_description"),
    isItemGroup: true,
    options: [
      {
        key: IMPORT_OPTION_KEYS.RATINGS_SINGLE,
        label: t("transcript:for_this_student"),
        icon: <StudentOutlined />,
      },
      {
        key: IMPORT_OPTION_KEYS.RATINGS_MULTIPLE,
        label: t("transcript:for_multiple_students"),
        icon: <MultipleUsersOutlined />,
      },
    ],
  },
  {
    key: "basic_details",
    label: t("transcript:bulk_import_basic_details"),
    subText: t("transcript:bulk_import_basic_details_description"),
    isItemGroup: true,
    options: [
      {
        key: IMPORT_OPTION_KEYS.BASIC_DETAILS_SINGLE,
        label: t("transcript:for_this_student"),
        icon: <StudentOutlined />,
      },
      {
        key: IMPORT_OPTION_KEYS.BASIC_DETAILS_MULTIPLE,
        label: t("transcript:for_multiple_students"),
        icon: <MultipleUsersOutlined />,
      },
    ],
  },
];
